<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">NCR User Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">NCR Number</label>
                <input type="text" class="form-control" id="ncr-no" v-model="ncr.ncrNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Reported Date</label>
                <flat-pickr class="form-control" v-model="ncr.ncrDate" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="subject">Addressed To</label>
                <app-lookup-field :model="ncr" :element="memberLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div class="form-group col-3">
                <label for="module">Non Conformance Name</label>
                <app-lookup-field :model="ncr" :element="conformanceTypeLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
            </div>
            <div class="form-group col-3">
                <label for="happened-before">Happened Before</label>
                <input type="checkbox" class="form-control" v-model="ncr.happenedBefore" id="happened-before">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="desc-textarea" v-model="ncr.description" rows="3"></textarea>
            </div>
        </div>
        <button v-if="!this.$route.query.id || (this.$route.query.id && this.ncr.userRole === 'admin')" type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { ncrUser } from '../../models/ncrUser'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppUploader from '../../components/AppUploader.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'


export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable, AppUploader
    },
    data() {
        return {
            ncr: {...ncrUser},
            memberLookup: {
                id: 'member',
                title: 'Member',
                type: 'form',
                apiUrl: 'member-management-list',
                filter: ['memberName'],
                fields: [
                    {
                        placeholder: 'Member',
                        width: 12,
                        column: 'memberName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'memberName'
                    },
                    {
                        title: 'Email',
                        column: 'email'
                    },
                    {
                        title: 'Department',
                        column: 'departmentName'
                    },
                    {
                        title: 'Division',
                        column: 'divisionName'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'memberId'
                    },
                    {
                        from: 'memberName',
                        to: 'memberName'
                    },
                ]
            },
            conformanceTypeLookup: {
                id: 'conformance-type',
                title: 'Conformance Type',
                type: 'form',
                apiUrl: 'conformance-type-list',
                filter: ['name'],
                fields: [
                    {
                        placeholder: 'Non Conformance Type',
                        width: 12,
                        column: 'conformanceTypeName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Nama',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'conformanceTypeId'
                    },
                    {
                        from: 'name',
                        to: 'conformanceTypeName'
                    },
                ]
          },
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const ncrApi = api('ncr-user')
            this.ncr = await ncrApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const ncrApi = api('ncr-user')
            if(this.$route.query.id !== undefined) {
                await ncrApi.update(this.ncr, this.$route.query.id)
            } else {
                await ncrApi.create(this.ncr)
                
            }
            this.$router.go(-1)
        },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentNcr = this.ncr
            this.ncr = {
                ...currentNcr,
                ...data
            }
        },
        finishUpload(data) {
            const currentNcr = this.ncr
            this.ncr = {
                ...currentNcr,
                ...data
            }
        },
    }
}
</script>